import React from 'react';
import { Checkbox } from 'antd';
import { CheckboxProps as CheckboxPropsProps } from 'antd/lib/checkbox';

export type CheckboxProps = CheckboxPropsProps;

const ProCheckbox: React.FC<CheckboxProps> = React.forwardRef<
  any,
  CheckboxProps
>((props, ref) => {
  const { children, ...resProps } = props;
  return (
    <Checkbox ref={ref} {...resProps}>
      {children}
    </Checkbox>
  );
});

export default ProCheckbox;
